module.exports = __webpack_public_path__ + "static/media/zj.66925732.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/record/images/zj.png
// module id = 1483
// module chunks = 0